import { CALL_API } from 'redux-api-middleware'
import { createCSVFromArrayOfObjects } from '../utils/helpers'

export const APP_CONTEXT_PARTNERS_REQUEST = 'appContext/PARTNERS_REQUEST'
export const APP_CONTEXT_PARTNERS_RECEIVE = 'appContext/PARTNERS_RECEIVE'
export const APP_CONTEXT_PARTNERS_FAILURE = 'appContext/PARTNERS_FAILURE'
export const APP_CONTEXT_REQUEST = 'appContext/CONTEXT_REQUEST'
export const APP_CONTEXT_RECEIVE = 'appContext/CONTEXT_RECEIVE'
export const APP_CONTEXT_FAILURE = 'appContext/CONTEXT_FAILURE'
export const FETCH_APPLICATION_REQUEST = 'appContext/FETCH_APPLICATION_REQUEST'
export const FETCH_APPLICATION_RECEIVE = 'appContext/FETCH_APPLICATION_RECEIVE'
export const FETCH_APPLICATION_FAILURE = 'appContext/FETCH_APPLICATION_FAILURE'
export const PREPOPULATE_PARTNERS = 'appContext/PREPOPULATE_PARTNERS'
export const SET_APP_CONTEXT_REQUEST = 'appContext/SET_APP_CONTEXT_REQUEST'
export const SET_APP_CONTEXT_RECEIVE = 'appContext/SET_APP_CONTEXT_RECEIVE'
export const SET_APP_CONTEXT_FAILURE = 'appContext/SET_APP_CONTEXT_FAILURE'
export const SET_SHOW_PROGRESS = 'appContext/SET_SHOW_PROGRESS'
export const SHOW_APP_CONTEXT_DIALOG = 'appContext/SHOW_APP_CONTEXT_DIALOG'
export const UPDATE_FORM_SELECTION = 'appContext/UPDATE_FORM_SELECTION'

const initialState = {
  appInfo: {
    email: '',
    id: '',
    name: '',
    url: '',
  },
  initialValues: {},
  showAppContextDialog: true,
  showProgressIndicator: false
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_CONTEXT_RECEIVE:
      let appInfo = action.payload.appInfo
      if (appInfo) {
        return {
          ...state,
          appInfo,
          initialValues: { ...state.initialValues, appId: appInfo.id }
        }
      }
      return {
        ...state
      }
    case APP_CONTEXT_PARTNERS_RECEIVE:
      window.localStorage.setItem('partners', JSON.stringify(action.payload.data.items))
      return {
        ...state,
        initialValues: {
          ...state.initialValues,
          partnerIds: action.payload.message.includes('Missing Partners:') ?
            ' ' : createCSVFromArrayOfObjects(action.payload.data.items, 'id')
        },
        showProgressIndicator: false,
        showAppContextDialog: action.payload.message !== ''
      }
    case PREPOPULATE_PARTNERS:
      return {
        ...state,
        initialValues: { ...state.initialValues, partnerIds: createCSVFromArrayOfObjects(action.partners, 'id') }
      }
    case SET_APP_CONTEXT_RECEIVE:
      return {
        ...state,
        appInfo: action.meta.appInfo,
        initialValues: { ...state.initialValues, appId: action.meta.appInfo.id }
      }
    case SET_SHOW_PROGRESS:
      return {
        ...state,
        showProgressIndicator: action.show
      }
    case SHOW_APP_CONTEXT_DIALOG:
      return {
        ...state,
        showAppContextDialog: action.show
      }
    case UPDATE_FORM_SELECTION:
      return {
        ...state,
        initialValues: {...state.initialValues, appId: action.appClientId}
      }
    default:
      return state
  }
}

export function fetchAppContext() {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/appContext` : '/appContext',
      method: 'GET',
      credentials: 'include',
      types: [APP_CONTEXT_REQUEST, APP_CONTEXT_RECEIVE, APP_CONTEXT_FAILURE]
    }
  }
}

export function setAppContext(appClientId) {
  return (dispatch) => {
    return dispatch(fetchAppInfo(appClientId))
    .then((res) => { 
      let appInfo = res.payload.data.item
      return dispatch(setAppContextCookie(appInfo))
    })
  }
}

function setAppContextCookie(appInfo) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/appContext` : '/appContext',
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        body: JSON.stringify(appInfo),
        types: [SET_APP_CONTEXT_REQUEST,
          {
            type: SET_APP_CONTEXT_RECEIVE,
            meta: {appInfo}
          },
          SET_APP_CONTEXT_FAILURE]
      }
    })
  }
}

export function fetchAppInfo(appId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? buildLocalAppEndpoint(appId) : `/api/v1/authz/applications/${appId}`,
      method: 'GET',
      credentials: 'include',
      types: [FETCH_APPLICATION_REQUEST, FETCH_APPLICATION_RECEIVE, FETCH_APPLICATION_FAILURE]
    }
  }
}

const buildLocalAppEndpoint = (appClientId) => {
  const localEndpoint = `http://localhost:8080/api/v1/authz/applications/${appClientId}`
  switch(appClientId) {
    case '0oaetestpz0h7':
    case 'mockedIDNoURL':
      return `${localEndpoint}/${appClientId}`
    default:
      return localEndpoint
  }
}

export function fetchPartners(partnerId) {
  const trimmedPartnerId = partnerId.replace(/\s/g,'')

  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/partners?partnerIds=${trimmedPartnerId}` :
        `/api/v1/authz/partners?partnerIds=${trimmedPartnerId}`,
      credentials: 'include',
      method: 'GET',
      types: [APP_CONTEXT_PARTNERS_REQUEST, APP_CONTEXT_PARTNERS_RECEIVE, APP_CONTEXT_PARTNERS_FAILURE]
    }
  }
}

export const prePopulatePartnerIds = (partners) => ({ type: PREPOPULATE_PARTNERS, partners })
export const setShowContext = (show) => ({ type: SHOW_APP_CONTEXT_DIALOG, show })
export const setShowProgressIndicator = (show) => ({ type: SET_SHOW_PROGRESS, show })
export const updateContextSelection = (appClientId) => ({ type: UPDATE_FORM_SELECTION, appClientId })

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
